






import RightTabs from '@/components/right-tabs'
export default {
  name: 'details-view',
  components: {
    RightTabs
  },
  mounted() {
  },
  props: [
    'redraw'
  ]
}



// WEBPACK FOOTER //
// ./src/components/details-view.vue